import { BarChart } from '../../../renderers/bar-chart/bar-chart.component';
import { ChartRendererProps } from '../../../types/chart-renderer-props';
import { TRANSACTION_TIMER_PICK_UP_PENDING_COMPLETED_VOLUME_BAR_CHART_DEFINITION } from './transaction-timer-pick-up-pending-completed-volume-bar-chart.definition';
import { TRANSACTION_TIMER_PICK_UP_PENDING_COMPLETED_VOLUME_BAR_CHART_MOCK_DATA } from './transaction-timer-pick-up-pending-completed-volume-bar-chart.mock';

export const TransactionTimerPickUpPendingCompletedVolumeBarChart = (props: ChartRendererProps) => <BarChart {...props} />;

TransactionTimerPickUpPendingCompletedVolumeBarChart.definition = TRANSACTION_TIMER_PICK_UP_PENDING_COMPLETED_VOLUME_BAR_CHART_DEFINITION;
TransactionTimerPickUpPendingCompletedVolumeBarChart.mockData = TRANSACTION_TIMER_PICK_UP_PENDING_COMPLETED_VOLUME_BAR_CHART_MOCK_DATA;
